import React from 'react';
import MaintenanceItem from './MaintenanceItem';
import FuelGauge from './FuelGauge';
import MileageTracker from './MileageTracker';
import FuelTracker from './FuelTracker';

interface CockpitProps {
  car: any;
  onClose: () => void;
  onUpdate: () => void;
  onAddService: (carId: number) => void;
}

const Cockpit: React.FC<CockpitProps> = ({ car, onClose, onUpdate, onAddService }) => {
  return (
    <div className="cockpit-overlay">
      <div className="cockpit-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div style={{ width: '60px', height: '60px', borderRadius: '50%', overflow: 'hidden', border: '2px solid var(--accent-color)' }}>
             {car.photo_url ? <img src={car.photo_url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : '🚗'}
          </div>
          <div>
            <h2 style={{ margin: 0 }}>{car.make} {car.model}</h2>
            <div style={{ fontSize: '0.8rem', color: 'var(--accent-color)' }}>SISTEMA DE DIAGNÓSTICO ACTIVO</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <button className="btn btn-primary" style={{ padding: '0.6rem 1.2rem', fontSize: '0.8rem' }} onClick={() => onAddService(car.id)}>
             + REGISTRAR SERVICE
          </button>
          <button className="btn-close-cockpit" onClick={onClose}>
            <span style={{ fontSize: '1.2rem' }}>◂</span> SALIR
          </button>
        </div>
      </div>

      <div className="instrument-cluster-max">
        <div className="cluster-frame">
          <div className="cluster-main-container">
            {/* Gauge Izquierdo (RPM / Consumo) */}
            <div className="large-gauge">
               <div className="value">{car.reminders ? car.reminders.filter((r:any) => r.status === 'ok').length : 0}</div>
               <div className="label">SYSTEMS OK</div>
            </div>

            {/* Centro: Todos los testigos organizados */}
            <div className="witness-grid-max">
              {car.reminders && car.reminders.map((r: any) => (
                <div key={r.type_id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                  <MaintenanceItem reminder={r} currentMileage={car.current_mileage} />
                  <div style={{ fontSize: '0.6rem', color: r.status === 'overdue' ? '#ff3b30' : '#444', fontWeight: 'bold', textAlign: 'center' }}>
                    {r.type_name.split(' ')[0]}
                  </div>
                </div>
              ))}
            </div>

            {/* Gauge Derecho (Kilometraje) */}
            <div className="large-gauge">
               <div className="value">{Math.floor(parseInt(car.current_mileage) / 1000)}k</div>
               <div className="label">TOTAL KM</div>
            </div>
          </div>

          <div className="ticker-container" style={{ marginTop: '2rem', borderLeft: '3px solid var(--accent-color)' }}>
             <div className={`ticker-text ${car.reminders && car.reminders.some((r:any) => r.status === 'overdue') ? 'warning' : ''}`}>
                {(() => {
                  const overdue = car.reminders ? car.reminders.filter((r:any) => r.status === 'overdue') : [];
                  const msg = overdue.length > 0 
                    ? `ATENCIÓN REQUERIDA: ${overdue.map((r:any) => `FALTA ${r.type_name.toUpperCase()}`).join(' --- ')} --- VERIFICAR SISTEMAS INMEDIATAMENTE --- `
                    : 'SISTEMAS OPERANDO NORMALMENTE --- CHEQUEO DE SEGURIDAD COMPLETADO --- BUEN VIAJE --- ';
                  return msg + msg + msg;
                })()}
             </div>
          </div>
        </div>

        {/* Bottom Panels - Added responsive flex container */}
        <div style={{ display: 'flex', gap: '1rem', width: '100%', marginTop: '1.5rem', flexWrap: 'wrap' }}>
           <div className="card" style={{ flex: '1 1 300px', background: 'rgba(0,0,0,0.5)', padding: '1rem' }}>
              <FuelTracker carId={car.id} onUpdate={onUpdate} />
           </div>
           <div className="card" style={{ flex: '1 1 300px', background: 'rgba(0,0,0,0.5)', padding: '1rem' }}>
              <MileageTracker carId={car.id} onUpdate={onUpdate} />
           </div>
        </div>
      </div>
    </div>
  );
};

export default Cockpit;
